/**
 * Client-side approval-context gate for the bulk create dialog (BULK-2).
 *
 * Mirrors the backend fail-fast in bulk-operation.service.ts (services/
 * communication): a bulk that requires approval must define a projectId and at
 * least one policyId — the approvals service rejects both otherwise
 * (F2: the prod 503 "Approval request rejected (HTTP 400)" came from the UI
 * never sending projectId/policyIds in the first place).
 *
 * Kept as a standalone pure module so the rule is unit-testable without
 * pulling the page's component graph (json editor / monaco) into vitest.
 */

export interface BulkApprovalForm {
  requiresApproval: boolean;
  projectId: string;
  policyIds: string[];
}

/** Returns an error message when the approval context is invalid, else `null`. */
export function assertApprovalContext(form: BulkApprovalForm): string | null {
  if (!form.requiresApproval) return null;
  if (!form.projectId.trim()) return 'Select a project (required for approval)';
  if (form.policyIds.length === 0) return 'Select at least one policy (required for approval)';
  return null;
}